import { useMemo } from 'react';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { FiltersDisplay } from 'customer-data-filters-ui/public/components';
import { getEventDateFilterProperty } from './event-date-filter-property';
// @ts-expect-error untyped import
import { getEventDateTableLabel } from '../../event-date-interval-utils';
import { useSnowflakeEventDateStrategy } from '../../strategies/use-event-date-strategy';
// @ts-expect-error untyped import
import { useTableDescription, useTableSource } from '../SourceMeta';
import { transformToFilterBranch } from '../../../../utils/filter-utils';
//@ts-expect-error untyped import
import { EVENT_DATE_PROPERTY_NAME } from '../../event-date-interval-utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EventDateFiltersDisplayView = ({
  filter
}) => {
  const property = getEventDateFilterProperty();
  const tableDescription = useTableDescription();
  const {
    name: tableName
  } = tableDescription || {
    name: ''
  };
  const source = useTableSource(tableName);
  const strategy = useSnowflakeEventDateStrategy({
    source
  });
  const {
    filter: propertyFilter
  } = filter;
  const hasOperation = propertyFilter && propertyFilter.get('operation');
  const filtersDisplayValue = useMemo(() => {
    if (!hasOperation) {
      return null;
    }
    return transformToFilterBranch(filter, EVENT_DATE_PROPERTY_NAME);
  }, [filter, hasOperation]);
  const baseFilterFamily = useMemo(() => {
    return (source === null || source === void 0 ? void 0 : source.dataSourceId) || 'event';
  }, [source]);
  if (!hasOperation) {
    return /*#__PURE__*/_jsx(Text, {
      children: /*#__PURE__*/_jsx("strong", {
        children: property.label
      })
    });
  }
  if (!strategy || !filtersDisplayValue) {
    return /*#__PURE__*/_jsx(Text, {
      children: /*#__PURE__*/_jsx("strong", {
        children: property.label
      })
    });
  }
  return /*#__PURE__*/_jsx(FiltersDisplay, {
    baseFilterFamily: baseFilterFamily,
    strategy: strategy,
    value: filtersDisplayValue
  });
};
const AllEventsFilterDisplayLabel = ({
  filter
}) => {
  const tableLabel = getEventDateTableLabel();
  return /*#__PURE__*/_jsxs(View, {
    children: [/*#__PURE__*/_jsx(Text, {
      display: "block",
      as: "strong",
      marginBlockEnd: "100",
      children: tableLabel
    }), /*#__PURE__*/_jsx(View, {
      children: /*#__PURE__*/_jsx(EventDateFiltersDisplayView, {
        filter: filter
      })
    })]
  });
};
export default AllEventsFilterDisplayLabel;